import { setSelectedAccount } from '../api/SessionApi';

export const EntityType = {
    CLIENT: 'client',
    ACCOUNT: 'account',
};

const EntityProperty = {
    CLIENT: 'client_selected',
    ACCOUNT: 'account_selected',
    ALL_ACCOUNTS: 'All accounts',
};

export const isAllAccounts = ({ client_selected: clientSelected = {} }) => (
    clientSelected.id === undefined
    && clientSelected.selected
    && clientSelected.name === EntityProperty.ALL_ACCOUNTS
);

export const getEntityType = ({ client_selected: clientSelected = {} }) => (
    clientSelected.selected ? EntityType.CLIENT : EntityType.ACCOUNT
);

export const getEntityId = (selectedObject) => {
    if (isAllAccounts(selectedObject)) return 'all';

    const entityType = selectedObject.isAccountSelected
        ? EntityProperty.ACCOUNT
        : EntityProperty.CLIENT;

    const entity = selectedObject[entityType];
    return entity && entity.id;
};

// TODO(#497) move to redux actions and middleware/
// https://github.com/paretogroup/platform-spa/issues/497
let isUpdatingSelectedObject = false;
export const changeSelectedClient = (accountSelected, type, callback) => {
    if (isUpdatingSelectedObject || !accountSelected) {
        return null;
    }

    const field = type === EntityType.ACCOUNT ? EntityProperty.ACCOUNT : EntityProperty.CLIENT;
    const data = {
        [field]: accountSelected.toString().trim(),
    };

    isUpdatingSelectedObject = true;
    return setSelectedAccount(data)
        .then((res) => {
            isUpdatingSelectedObject = false;
            if (callback) callback();
            return res;
        })
        .catch((err) => {
            isUpdatingSelectedObject = false;
            return Promise.reject(err);
        });
};
